"use client";

import React, {
  useCallback,
  useEffect,
  useState,
  FC,
  HTMLAttributes,
  Fragment,
} from "react";
import ReactDOM from "react-dom";
import Flickity from "flickity"

interface Props extends HTMLAttributes<HTMLDivElement & Flickity> {
  flickityRef?: (flickity: Flickity) => void;
  onStaticClick?: (
    event: any,
    pointer: any,
    cellElement: any,
    cellIndex: any
  ) => any;
  options: Flickity.Options;
}

const Carousel: FC<Props> = ({
  flickityRef,
  options,
  children,
  className,
  ...props
}) => {
  let Flickity: any = function () {};
  if (typeof window !== "undefined") {
    Flickity = require("flickity");
    require("flickity-as-nav-for");
  }
  const [flickityReady, setFlickityReady] = useState(false);

  const [flickityNode, setFlickityNode] = useState<HTMLDivElement>();
  const [flickity, setFlickity] = useState<Flickity>();

  const renderPortal = () => {
    if (!flickityNode) {
      return null;
    }

    const mountNode = flickityNode.querySelector(".flickity-slider");

    if (mountNode) {
      return ReactDOM.createPortal(children, mountNode);
    }
    return null;
  };

  const refreshFlickity = useCallback(() => {
    flickity?.reloadCells();
    flickity?.resize();
  }, [flickity]);

  useEffect(() => {
    if (!flickityNode) {
      return;
    }
    setFlickity((p) => {
      if (!!p) {
        return p;
      }
      return new Flickity(flickityNode, options || {});
    });
    setFlickityReady(true);
  }, [flickityNode]);

  useEffect(() => {
    if (flickityReady) {
      refreshFlickity();
    }
  });

  useEffect(() => {
    if (flickityRef && flickity) {
      flickityRef(flickity);
    }
  }, [flickityRef, flickity]);

  const RenderChildren = () => children ? (
    React.Children.map(children, (child: any) => {
      if (!child) {
        return child
      }
      return React.cloneElement(child, { })
   })
  ) : <></>

  useEffect(() => {
    let time = 5
    refreshFlickity()
    let interval = setInterval(() => {
      if (time <= 0) {
        clearInterval(interval)
        return
      }
      refreshFlickity()
      time--
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [refreshFlickity])
  return (
    <Fragment>
      <div
        style={{ display: 'none' }}
      >
        {!flickityReady && <RenderChildren />}
        </div>
      {[
        <div
          className={`flickity-react${className ? " " + className : ""}`}
          key={"flickityBase"}
          ref={(node: HTMLDivElement) => setFlickityNode(node)}
          {...props}
          style={{
            ...props.style,
            ...(flickityReady ? {  } : { display: 'none' })
          }}
        />,
        renderPortal(),
      ].filter(Boolean)}
    </Fragment>
  );
};

export default Carousel;
